<template>
    <form v-if="isTopForm" :class="classes" :autocomplete="autocomplete">
        <slot
            v-bind="{
                finalReadonly,
                finalDisabled,
                finalViewonly,
                finalEditable,
                finalRequired,
                finalProp,
                finalRules,
                hasRuleRequired,
            }"
        ></slot>
    </form>
    <!-- form元素不允许嵌套 -->
    <div v-else :class="classes">
        <slot
            v-bind="{
                finalReadonly,
                finalDisabled,
                finalViewonly,
                finalEditable,
                finalRequired,
                finalProp,
                finalRules,
                hasRuleRequired,
            }"
        ></slot>
    </div>
</template>
<script>
import Field from '../../mixins/field'
import { oneOf } from '../../utils/assist'

const prefixCls = 'ivu-form'

export default {
    name: 'iForm',
    mixins: [Field],
    props: {
        labelWidth: {
            type: Number,
            default: null,
        },
        labelHeight: {
            type: Number,
            default: null,
        },
        itemHeight: {
            type: Number,
            default: null,
        },
        itemMarginBottom: {
            type: Number,
        },
        labelPosition: {
            validator(value) {
                return oneOf(value, ['left', 'right', 'top'])
            },
            default: 'right',
        },
        inline: {
            type: Boolean,
            default: false,
        },
        showMessage: {
            type: Boolean,
            default: true,
        },
        autocomplete: {
            validator(value) {
                return oneOf(value, ['on', 'off'])
            },
            default: 'off',
        },
    },
    provide() {
        return { form: this }
    },
    inject: {
        parentForm: {
            from: 'form',
            default: null,
        },
    },
    computed: {
        isTopForm() {
            return this.parentForm === null
        },

        classes() {
            return [
                `${prefixCls}`,
                `${prefixCls}-label-${this.labelPosition}`,
                {
                    [`${prefixCls}-inline`]: this.inline,
                },
            ]
        },
    },
}
</script>
